// Mock data for Lexprive Consultants LLP

export const companyInfo = {
  name: "Lexprive Consultants LLP",
  tagline: "Securing Your Digital Future with Expert Data Protection Solutions",
  email: "info@lexprive.in",
  phone: "+91 93406 16763",
  whatsapp: "+91 91093 71203",
  address: "Chamber No. 317, Third Floor, Shankar Nagar Studio Complex, Opposite Gurudwara, Raipur, Chhattisgarh - 492001",
  coordinates: "21.2532900, 81.6623340"
};

export const heroData = {
  headline: "Navigate India's Data Protection Landscape with Confidence",
  subheadline: "Expert DPDPA Compliance Solutions for Startups, MSMEs & Corporates",
  highlights: [
    "DPDPA Certified Consultants",
    "Specialized in Healthcare, E-commerce & SaaS",
    "Trusted by Leading Indian Enterprises"
  ],
  backgroundImage: "https://images.pexels.com/photos/7841457/pexels-photo-7841457.jpeg"
};

export const aboutData = {
  title: "About Lexprive Consultants LLP",
  description: "We are a specialized data protection consultancy dedicated to helping Indian and Overseas businesses navigate the complexities of the Digital Personal Data Protection Act (DPDPA). Our team of legal and compliance experts provides comprehensive solutions that protect your business while ensuring regulatory compliance.",
  mission: "Our mission is to simplify data protection compliance for businesses of all sizes, enabling them to build trust with their customers while meeting legal requirements.",
  expertise: [
    "Deep understanding of DPDPA and global privacy regulations",
    "Practical, business-focused compliance strategies",
    "Industry-specific data protection solutions",
    "Ongoing support and advisory services"
  ]
};

export const servicesData = [
  {
    id: 1,
    title: "Privacy & Cookie Notices",
    description: "Advising and drafting DPDPA compliant privacy and cookie notices tailored to your business operations and data processing activities.",
    icon: "FileText",
    image: "https://images.unsplash.com/photo-1633265486064-086b219458ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxkYXRhJTIwc2VjdXJpdHl8ZW58MHx8fHwxNzY5NDQ2NzU2fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Records of Processing Activity (ROPA)",
    description: "Creating comprehensive ROPA documentation to maintain transparency and accountability in your data processing operations.",
    icon: "Database",
    image: "https://images.unsplash.com/photo-1614064641938-3bbee52942c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxkYXRhJTIwc2VjdXJpdHl8ZW58MHx8fHwxNzY5NDQ2NzU2fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Privacy Training & Awareness",
    description: "Comprehensive training programs to educate your team on DPDPA requirements, best practices, and data protection principles.",
    icon: "GraduationCap",
    image: "https://images.unsplash.com/photo-1548092372-0d1bd40894a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxkYXRhJTIwc2VjdXJpdHl8ZW58MHx8fHwxNzY5NDQ2NzU2fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    title: "Data Audits & DPIA",
    description: "Conducting thorough data audits and Data Protection Impact Assessments for startups, MSMEs, and corporate entities.",
    icon: "Search",
    image: "https://images.pexels.com/photos/5380655/pexels-photo-5380655.jpeg"
  },
  {
    id: 5,
    title: "Data Protection Agreements",
    description: "Drafting DPDPA compliant Data Protection Agreements between Data Fiduciaries and Data Processors.",
    icon: "FileSignature",
    image: "https://images.unsplash.com/photo-1633265486064-086b219458ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxkYXRhJTIwc2VjdXJpdHl8ZW58MHx8fHwxNzY5NDQ2NzU2fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 6,
    title: "Internal Privacy Policies",
    description: "Drafting DPDPA compliant internal privacy policies covering employee data protection, vendor management, and organizational data handling practices.",
    icon: "Shield",
    image: "https://images.unsplash.com/photo-1614064641938-3bbee52942c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxkYXRhJTIwc2VjdXJpdHl8ZW58MHx8fHwxNzY5NDQ2NzU2fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 7,
    title: "Consent Management Policies",
    description: "Designing comprehensive consent management frameworks with granular user controls, transparent opt-in mechanisms, and easy consent withdrawal processes.",
    icon: "CheckCircle",
    image: "https://images.unsplash.com/photo-1548092372-0d1bd40894a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxkYXRhJTIwc2VjdXJpdHl8ZW58MHx8fHwxNzY5NDQ2NzU2fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 8,
    title: "Data Breach Policies",
    description: "Creating incident response frameworks, data breach notification procedures, and crisis management protocols to ensure swift and compliant breach handling.",
    icon: "AlertTriangle",
    image: "https://images.pexels.com/photos/5380655/pexels-photo-5380655.jpeg"
  },
  {
    id: 9,
    title: "Data Retention Policies",
    description: "Establishing compliant data retention schedules, secure deletion protocols, and lifecycle management frameworks aligned with DPDPA requirements.",
    icon: "Clock",
    image: "https://images.unsplash.com/photo-1633265486064-086b219458ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxkYXRhJTIwc2VjdXJpdHl8ZW58MHx8fHwxNzY5NDQ2NzU2fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 10,
    title: "DPDPA Roadmap & Gap Assessment",
    description: "Creating and advising on DPDPA compliant roadmaps including comprehensive gap assessments for your organization.",
    icon: "Map",
    image: "https://images.unsplash.com/photo-1548092372-0d1bd40894a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxkYXRhJTIwc2VjdXJpdHl8ZW58MHx8fHwxNzY5NDQ2NzU2fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 11,
    title: "Cross-Border Data Transfers",
    description: "Advisory on international data transfer compliance, implementing appropriate safeguards, and ensuring DPDPA adherence for global data flows.",
    icon: "Globe",
    image: "https://images.pexels.com/photos/5380655/pexels-photo-5380655.jpeg"
  },
  {
    id: 12,
    title: "Cross-Border Transfer Agreements",
    description: "Drafting legally binding Data Transfer Agreements with Standard Contractual Clauses for secure international data transfers compliant with DPDPA.",
    icon: "FileText",
    image: "https://images.unsplash.com/photo-1614064641938-3bbee52942c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxkYXRhJTIwc2VjdXJpdHl8ZW58MHx8fHwxNzY5NDQ2NzU2fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 13,
    title: "Grievance Redressal Mechanism",
    description: "Creating effective grievance redressal mechanisms to address data principal concerns and maintain compliance.",
    icon: "MessageSquare",
    image: "https://images.pexels.com/photos/5380655/pexels-photo-5380655.jpeg"
  },
  {
    id: 14,
    title: "Data Mapping",
    description: "Comprehensive data mapping services to identify, categorize, and document all personal data flows within your organization.",
    icon: "GitBranch",
    image: "https://images.unsplash.com/photo-1633265486064-086b219458ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxkYXRhJTIwc2VjdXJpdHl8ZW58MHx8fHwxNzY5NDQ2NzU2fDA&ixlib=rb-4.1.0&q=85"
  }
];

export const caseStudiesData = [
  {
    id: 1,
    client: "EdTech Learning Platform",
    industry: "Education Technology",
    challenge: "Platform processing student data including minors' information required comprehensive DPDPA compliance framework. Needed to implement parental consent mechanisms, secure data handling for educational content, and transparent privacy practices while maintaining seamless user experience.",
    solution: "Developed complete privacy framework with age-gated consent mechanisms, cookie management system, and transparent data usage policies. Implemented robust security protocols for protecting student data and created comprehensive privacy notices compliant with DPDPA requirements.",
    results: "Achieved full DPDPA compliance within 90 days. Implemented granular consent framework for 500,000+ users. Zero data breach incidents. Successfully onboarded 200+ educational institutions with confidence in data protection practices.",
    tools: ["Cookie Notice Framework", "Consent Management", "Privacy Policies", "Security Audit"]
  },
  {
    id: 2,
    client: "FinTech Payment Solutions Provider",
    industry: "Financial Technology",
    challenge: "High-risk processing of sensitive financial data including UPI transactions, digital wallets, and customer KYC information. Required stringent compliance measures for cross-border data transfers to payment gateways and meeting RBI data localization norms alongside DPDPA requirements.",
    solution: "Conducted comprehensive DPIA, implemented data localization infrastructure, drafted cross-border data transfer agreements with Standard Contractual Clauses, and established robust consent management for financial transactions. Created internal privacy policies and data breach response protocols.",
    results: "Protected ₹100 crore+ monthly transaction volume. Achieved zero compliance violations during regulatory audits. Successfully implemented cross-border payment gateway integrations while maintaining full data sovereignty. Established trusted fintech compliance framework.",
    tools: ["DPIA", "Cross-Border Transfer Agreements", "Data Breach Policies", "Internal Privacy Policies"]
  },
  {
    id: 3,
    client: "Multi-Specialty Hospital & Diagnostic Lab Chain",
    industry: "Healthcare",
    challenge: "Processing highly sensitive patient health records, diagnostic reports, genetic data, and medical imaging across 20+ facilities. Required balancing patient privacy with healthcare operational needs, implementing secure data sharing between hospitals and labs, and ensuring DPDPA compliance for sensitive personal data.",
    solution: "Developed comprehensive healthcare data protection framework including consent management for sensitive health data, data retention policies aligned with medical records regulations, secure data sharing protocols between facilities, and privacy-preserving analytics implementation for corporate wellness programs.",
    results: "Successfully secured 2 million+ patient records across facilities. Implemented end-to-end encryption for diagnostic data transfers. Achieved 100% DPIA compliance for sensitive data processing. Zero patient data breach incidents across all facilities. Enhanced patient trust and regulatory confidence.",
    tools: ["Data Protection Agreements", "Consent Management Policies", "Data Retention Policies", "DPIA"]
  },
  {
    id: 4,
    client: "Food Delivery & Gaming Applications",
    industry: "Consumer Technology",
    challenge: "Food delivery app processing real-time location data, payment information, and user preferences. Gaming platform handling user behavior analytics, in-app purchases, and social features. Both required transparent consent mechanisms, secure cross-border data transfers to cloud providers, and compliance with DPDPA for behavioral tracking.",
    solution: "Designed granular consent frameworks for location tracking and behavioral analytics. Implemented privacy dashboards enabling user control over data sharing. Drafted cross-border data transfer agreements for AWS/GCP cloud infrastructure. Created comprehensive cookie notices and data retention policies balancing business analytics needs with user privacy.",
    results: "Food delivery app: Implemented compliant location tracking for 5 million+ users. Gaming platform: Achieved 95% user consent rate with transparent privacy controls. Both platforms: Zero privacy violations, successful app store approvals, and enhanced user trust metrics by 40%.",
    tools: ["Consent Management", "Cross-Border Transfer Agreements", "Privacy Dashboard", "Cookie Policies"]
  }
];

export const whyChooseUsData = [
  {
    title: "DPDPA Expertise",
    description: "Deep knowledge of India's Digital Personal Data Protection Act and its practical implementation.",
    icon: "Award"
  },
  {
    title: "Practical Approach",
    description: "Business-friendly solutions that balance compliance requirements with operational efficiency.",
    icon: "Target"
  },
  {
    title: "Industry Experience",
    description: "Experience across diverse sectors including tech, healthcare, finance, e-commerce, and manufacturing.",
    icon: "Briefcase"
  },
  {
    title: "End-to-End Support",
    description: "From initial assessment to ongoing compliance monitoring and updates.",
    icon: "LifeBuoy"
  },
  {
    title: "Cost-Effective",
    description: "Tailored solutions for startups, MSMEs, and corporates with transparent pricing.",
    icon: "DollarSign"
  },
  {
    title: "Timely Delivery",
    description: "Proven track record of delivering compliance projects within agreed timelines.",
    icon: "Clock"
  }
];

export const blogData = [
  {
    id: 1,
    title: "Understanding DPDPA: A Complete Guide for Indian Businesses",
    excerpt: "The Digital Personal Data Protection Act marks a new era in India's data privacy landscape. Learn what it means for your business.",
    date: "2024-12-15",
    category: "Compliance",
    readTime: "8 min read",
    author: "Lexprive Team"
  },
  {
    id: 2,
    title: "Data Fiduciary vs Data Processor: Key Differences Explained",
    excerpt: "Understanding the roles and responsibilities under DPDPA is crucial for compliance. We break down the key distinctions.",
    date: "2024-12-10",
    category: "Legal Insights",
    readTime: "6 min read",
    author: "Lexprive Team"
  },
  {
    id: 3,
    title: "Implementing Consent Management: Best Practices",
    excerpt: "Effective consent management is at the heart of DPDPA compliance. Discover best practices for your organization.",
    date: "2024-12-05",
    category: "Best Practices",
    readTime: "7 min read",
    author: "Lexprive Team"
  },
  {
    id: 4,
    title: "DPIA: When and How to Conduct Data Protection Impact Assessments",
    excerpt: "Learn when your organization needs to conduct DPIA and how to approach it systematically.",
    date: "2024-11-28",
    category: "Technical",
    readTime: "10 min read",
    author: "Lexprive Team"
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Mr. Ahad Siddiqui",
    position: "Director, Grabby Innovations Private Limited",
    company: "Quick Commerce Platform",
    content: "Working with Lexprive Consultants has been instrumental in establishing our DPDPA compliance framework. Their expertise in data protection law and practical approach helped us navigate complex compliance requirements while maintaining our operational efficiency. Highly recommended for any business dealing with sensitive customer data.",
    rating: 5,
    avatar: "AS"
  },
  {
    id: 2,
    name: "Mr. Rohit Sinha",
    position: "Director, Aharams Ventures Private Limited",
    content: "Lexprive Consultants provided exceptional guidance on our data protection strategy. Their deep understanding of DPDPA requirements and ability to translate complex legal concepts into actionable business strategies made the compliance journey smooth and efficient. Their professionalism and expertise are unmatched.",
    rating: 5,
    avatar: "RS"
  }
];

export const founderData = {
  name: "Hasnain Alvi",
  title: "Founder and Managing Partner",
  education: "B.A. LL.B (Hons.) - Hidayatullah National Law University, Raipur",
  certification: "Certified Data Protection Officer",
  experience: "10+ Years",
  image: "/founder.jpg", // Placeholder until you provide the photo
  bio: "Mr. Hasnain Alvi, Founder and Managing Partner at Lexprive Consultants LLP, is a dedicated legal professional with over 10 years of comprehensive experience, combining expertise in Data Protection, Privacy Law, and Intellectual Property with a robust foundation in Commercial & Corporate Litigation including Corporate Advisory. Having graduated with B.A. LL.B (Hons.) from Hidayatullah National Law University, Raipur, and being a Certified Data Protection Officer, he brings both academic rigor and practical dispute resolution skills to every engagement.",
  expertise: {
    title: "🔐 Data Protection & Privacy Practice",
    description: "Advising businesses on compliance with India's new Digital Personal Data Protection Act, 2023 (DPDP Act), data governance frameworks, drafting DPDPA Compliant Privacy & Cookie Notices, data processing agreements, consent management system, creating tailored grievance redressal mechanism and data breach response protocols. I help organizations build privacy-by-design systems and navigate regulatory requirements."
  },
  specializations: [
    "DPDPA Compliance & Advisory",
    "Privacy Law & Data Governance",
    "Intellectual Property Law",
    "Commercial & Corporate Litigation",
    "Corporate Advisory & Dispute Resolution"
  ]
};

export const projectDeliverablesData = [
  {
    id: 1,
    title: "Consent Management Compliance Assessment",
    industry: "Technology Platforms",
    description: "Comprehensive DPDPA compliance assessment addressing consent management gaps for users, AI features, and data recording functionalities.",
    deliverables: [
      "Risk Analysis Memo",
      "User Journey Analysis",
      "Consent Mechanism Redesign",
      "Implementation Roadmap"
    ],
    fileUrl: "https://customer-assets.emergentagent.com/job_tech-showcase-239/artifacts/1b4wesfy_Week%2012%20DPDPA%20Exercise.docx",
    icon: "FileCheck"
  },
  {
    id: 2,
    title: "Cookie Consent & Privacy Dashboard Implementation",
    industry: "Digital Platforms",
    description: "Designed compliant cookie consent mechanism and user privacy dashboard enabling granular control and DPDPA compliance.",
    deliverables: [
      "Cookie Consent Framework",
      "Privacy Dashboard Design",
      "Consent Management System",
      "Mobile App Integration"
    ],
    fileUrl: "https://customer-assets.emergentagent.com/job_tech-showcase-239/artifacts/14u7la3z_DPDPA%20Week%2013%20exercise.docx",
    icon: "Cookie"
  },
  {
    id: 3,
    title: "Gap Analysis & 12-Month Compliance Roadmap",
    industry: "Enterprise Organizations",
    description: "Complete gap analysis identifying critical DPDPA violations and detailed 12-month implementation roadmap with budget allocation.",
    deliverables: [
      "Gap Analysis Report",
      "Risk Assessment",
      "Vendor Compliance Program",
      "Phased Implementation Plan"
    ],
    fileUrl: "https://customer-assets.emergentagent.com/job_tech-showcase-239/artifacts/0y8spm7b_DPDPA%20Week%2015%20exercise.docx",
    icon: "TrendingUp"
  },
  {
    id: 4,
    title: "Internal Privacy Policy Framework",
    industry: "Corporate Entities",
    description: "Comprehensive internal privacy policy covering employee and user data protection, vendor management, and data lifecycle.",
    deliverables: [
      "Internal Privacy Policy",
      "Data Retention Schedule",
      "Vendor Management Framework",
      "Security Protocols"
    ],
    fileUrl: "https://customer-assets.emergentagent.com/job_tech-showcase-239/artifacts/d7md540n_Week%2010%20dpdpa%20internal%20privacy%20policy%20exercise.docx",
    icon: "ShieldCheck"
  },
  {
    id: 5,
    title: "Data Protection Impact Assessment (DPIA)",
    industry: "Regulated Industries",
    description: "Mandatory DPIA addressing high-risk processing, cross-border transfers, and Significant Data Fiduciary obligations.",
    deliverables: [
      "DPIA Document",
      "AI Governance Framework",
      "Risk Mitigation Roadmap",
      "Stakeholder Consultation"
    ],
    fileUrl: "https://customer-assets.emergentagent.com/job_tech-showcase-239/artifacts/mjmt9dw6_DPDPA%20WEEK%2008%20EXERCISE.docx",
    icon: "FileSearch"
  },
  {
    id: 6,
    title: "DPDPA-Compliant Cookie Notice Framework",
    industry: "Technology Platforms",
    description: "Comprehensive cookie management framework ensuring granular consent, transparency, and full DPDPA compliance for tracking technologies.",
    deliverables: [
      "Cookie Notice Policy",
      "Cookie Inventory & Categorization",
      "Granular Consent Mechanism",
      "Third-Party Data Management"
    ],
    fileUrl: "https://customer-assets.emergentagent.com/job_tech-showcase-239/artifacts/d1xc2znm_DPDPA%20Week%207%20exercise.docx",
    icon: "Settings"
  }
];
